<section class="wrap" >
  <!-- <button appChangeColorTheme attribute="bgc" class="faQuestionCircle" (click)="openDialogHelp()" disabled [style.opacity]=".4">
    <fa-icon [icon]="getFaIcon('faQuestionCircle')"></fa-icon>
     Aide
  </button> -->
  <div class="add_trainee_mobile" (click)="openDialogAddOrEditTrainee('add')">
    <fa-icon [icon]="getFaIcon('faPlus')" appChangeColorTheme attribute="color"></fa-icon>
    Ajouter un stagiaire
  </div>

  <div class="trainees">
    <ng-container *ngFor="let t of trainees; let i = index">
      <div class="trainee">
        <mat-checkbox [color]="color" [checked]="t.checked" (change)="addOrDeleteTrainee($event, t, i)">
          {{t.traineeFirstName}} {{t.traineeLastName}}
          <fa-icon [icon]="getFaIcon('faInfoCircle')" class="red" *ngIf="t.hasParamsToSet" matTooltip="Vous devez remplir les paramètres de ce stagiaire pour finaliser la commande"></fa-icon>

        </mat-checkbox>
        <fa-icon [icon]="getFaIcon('faPen')" (click)="openDialogAddOrEditTrainee('edit', t)"></fa-icon>
      </div>
    </ng-container>
  </div>

  <p *ngIf="!canCloseDialog" class="important">Il reste des stagiaires avec des paramètres non remplis.</p>

  <div class="btn_action">
    <button class="confirm" (click)="dialogRef.close()" [disabled]="!canCloseDialog" [style.opacity]="canCloseDialog ? 1 : .5">Confirmer</button>
  </div>
</section>
